import React from 'react';
import PropTypes from 'prop-types';
import { Row, Text } from '../../../../../components/common';
import { cleanOrderId } from '../../../../../utils/misc';

export const DrawerTitle = ({ isBipickingGroup, orderId, icon }) => {
    if (isBipickingGroup) {
        const bipickingStyles = {
            borderBottom: '4px solid #a4c735',
            justifyContent: 'center',
            padding: 10,
            marginTop: 20,
            backgroundColor: 'white'
        };

        return (
            <Row style={bipickingStyles} justify='center'>
                <Text text='Auditoría órdenes bipicking' size={15} strong />
            </Row>
        );
    }

    const titleStyles = {
        borderBottom: '4px solid #a4c735',
        justifyContent: 'space-between',
        textAlign: 'center',
        padding: "8px 20px",
        gap: "4px",
        fontSize: 18,
    };

    const titleText = `${cleanOrderId(orderId)}`;

    return (
        <Row style={titleStyles} >
            {<div />}<div style={{
                gap: "4px",
                fontSize: 18,
            }}> Auditoría pedido:{<Text text={" " + titleText} size={18} strong />}</div>{icon}
        </Row>
    );
};

DrawerTitle.propTypes = {
    isBipickingGroup: PropTypes.bool,
    orderId: PropTypes.string
};